import { Controller } from '@hotwired/stimulus';
import tagTableDialogUtils from '../../concerns/tag_table_dialog_utils';

export default class extends Controller {
  static targets = [
    'list',
    'listItem',
    'order',
    'border',
    'dialogCheckBox',
    'listCheckBox',
  ];

  initialize() {
    tagTableDialogUtils(this);
  }

  connect() {
    this.displayCheckedListItem();
    this.reorder();
  }
}
